<template>
	<v-autocomplete
		v-model="person"
		:items="persons"
		:item-text="text"
		:item-value="value"
		dense
		outlined
		filled
		clearable
		label="Seleccione una persona"
		no-data-text="No hay personas"
		@change="setPerson"
	/>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
	props: {
		id: {
			type: String,
			default: '',
		},
		setPerson: {
			type: Function,
			required: true,
		},
		selected: {
			type: Number,
			default: null,
		},
	},
	data() {
		return {
			person: null,
			loading: false,
			items: [],
		};
	},
	computed: {
		...mapGetters({
			persons: 'Person/personsByUser',
		}),
	},
	watch: {
		id() {
			this.getPersons();
		},
		selected(newVal) {
			if (newVal !== 0) {
				this.person = null;
			}
		},
	},
	mounted() {
		if (this.id) {
			this.getPersons();
		}
	},
	methods: {
		getPersons() {
			this.loading = true;
			this.items = [];
			this.person = null;
			this.getPersonsByUser(this.id)
				.then(() => (this.loading = false))
				.catch(() => (this.loading = false));
		},
		text(text) {
			return `${text.firstName} ${text.lastName ? text.lastName : ''}`;
		},
		value(text) {
			return text;
		},
		...mapActions({
			getPersonsByUser: 'Person/getPersonsByUser',
		}),
	},
};
</script>
